import { useMutation } from "@apollo/client";
import { DELETE_LIVE_CRAWLER } from "graphql/facebookCrawler/mutation";
import i18n from "utils/i18n";
import { notifyError, notifySuccess } from "utils/notify";

export default (setIsOpenConfirmDeleteModal: Function, closeFrom: () => void) => {
  const [deleteLiveCrawler, { loading: deleteLiveCrawlerLoading }] = useMutation(DELETE_LIVE_CRAWLER, {
    onError: () => {
      notifyError(i18n.t("facebookLive.toast.fail"));
      setIsOpenConfirmDeleteModal(false);
    },
    onCompleted: () => {
      notifySuccess(i18n.t("facebookLive.toast.complete"));
      setIsOpenConfirmDeleteModal(false);
      closeFrom();
    },
  });
  return { deleteLiveCrawler, deleteLiveCrawlerLoading };
};
